
/* API CLIENT CONFIG */
export const API_TIMEOUT = process.env.REACT_APP_GB_API_TIME_OUT;
export const CLIENT_TIMEOUT = 600000;
export const API_MAX_RETRIES = 2;
export const API_RETRY_DELAY = 1000;
export const REACT_APP_ENV = process.env.REACT_APP_GB_ENV;

/* GENERIC ERROR MESSAGE */
export const ERROR_MESSAGE = {
    GENERIC_MESSAGE: 'Something went wrong. Please refresh the page.',
    ADDRESS_QUALIFICATION_FAIL: 'Address qualification failed. Please try again.',
    TN_FAIL: 'Failed to retrieve TNs for your zipcode',
    TECHNICAL_ISSUE: 'Something went wrong. please try again. If issue persists, please contact the customer support.'
};

export const ENABLE_OMNI_CART = process.env.REACT_APP_ENABLE_OMNI_CART;

export const UI_EVENT_LOGGING = process.env.REACT_APP_UI_EVENT_LOGGING;

export const ENABLE_AEM_CHANGES = process.env.REACT_APP_ENABLE_AEM_CHANGES;
export const REDIRECT_5G_URL = process.env.REACT_APP_GB_5G_URL;
export const REDIRECT_4G_URL = process.env.REACT_APP_GB_4G_URL;
export const VZW_OFFER_ELIGIBILITY_FLAG = process.env.REACT_APP_VZW_OFFER_ELIGIBILITY;
export const RED_SKY_ENABLED = process.env.REACT_APP_RED_SKY_ENABLED;
export const PRINT_CART = process.env.REACT_APP_PRINT_CART;
export const REDIRECT_DEVICES_URL = process.env.REACT_APP_GB_DEVICES_URL;
export const SHOW_CHAT_ASSITANCE_BDV = process.env.REACT_APP_SHOW_CHAT_ASSITANCE_BDV;
export const IN_NETWORK_STATES = ['NJ', 'PA', 'DE', 'NY', 'MA', 'RI', 'CT', 'MD', 'DC', 'VA', 'WV'];

// Google Recaptcha API Key
export const GOOGLE_RECAPTCHA_SITEKEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITEKEY;
export const LQ_UNIT_ENABLE= process.env.REACT_APP_LQ_UNIT_ENABLE;


export const STATE_SELECT = [
    {
        abbreviation: 'AL',
        stateName: 'Alabama'
    },
    {
        abbreviation: 'AK',
        stateName: 'Alaska'
    },
    {
        abbreviation: 'AS',
        stateName: 'American Samoa'
    },
    {
        abbreviation: 'AZ',
        stateName: 'Arizona'
    },
    {
        abbreviation: 'AR',
        stateName: 'Arkansas'
    },
    {
        abbreviation: 'CA',
        stateName: 'California'
    },
    {
        abbreviation: 'CO',
        stateName: 'Colorado'
    },
    {
        abbreviation: 'CT',
        stateName: 'Connecticut'
    },
    {
        abbreviation: 'DE',
        stateName: 'Delaware'
    },
    {
        abbreviation: 'DC',
        stateName: 'District of Columbia'
    },
    {
        abbreviation: 'FM',
        stateName: 'Federated States Of Micronesia'
    },
    {
        abbreviation: 'FL',
        stateName: 'Florida'
    },
    {
        abbreviation: 'GA',
        stateName: 'Georgia'
    },
    {
        abbreviation: 'GU',
        stateName: 'Guam'
    },
    {
        abbreviation: 'HI',
        stateName: 'Hawaii'
    },
    {
        abbreviation: 'ID',
        stateName: 'Idaho'
    },
    {
        abbreviation: 'IL',
        stateName: 'Illinois'
    },
    {
        abbreviation: 'IN',
        stateName: 'Indiana'
    },
    {
        abbreviation: 'IA',
        stateName: 'Iowa'
    },
    {
        abbreviation: 'KS',
        stateName: 'Kansas'
    },
    {
        abbreviation: 'KY',
        stateName: 'Kentucky'
    },
    {
        abbreviation: 'LA',
        stateName: 'Louisiana'
    },
    {
        abbreviation: 'ME',
        stateName: 'Maine'
    },
    {
        abbreviation: 'MH',
        stateName: 'Marshall Islands'
    },
    {
        abbreviation: 'MD',
        stateName: 'Maryland'
    },
    {
        abbreviation: 'MA',
        stateName: 'Massachusetts'
    },
    {
        abbreviation: 'MI',
        stateName: 'Michigan'
    },
    {
        abbreviation: 'MN',
        stateName: 'Minnesota'
    },
    {
        abbreviation: 'MS',
        stateName: 'Mississippi'
    },
    {
        abbreviation: 'MO',
        stateName: 'Missouri'
    },
    {
        abbreviation: 'MT',
        stateName: 'Montana'
    },
    {
        abbreviation: 'NE',
        stateName: 'Nebraska'
    },
    {
        abbreviation: 'NV',
        stateName: 'Nevada'
    },
    {
        abbreviation: 'NH',
        stateName: 'New Hampshire'
    },
    {
        abbreviation: 'NJ',
        stateName: 'New Jersey'
    },
    {
        abbreviation: 'NM',
        stateName: 'New Mexico'
    },
    {
        abbreviation: 'NY',
        stateName: 'New York'
    },
    {
        abbreviation: 'NC',
        stateName: 'North Carolina'
    },
    {
        abbreviation: 'ND',
        stateName: 'North Dakota'
    },
    {
        abbreviation: 'MP',
        stateName: 'Northern Mariana Islands'
    },
    {
        abbreviation: 'OH',
        stateName: 'Ohio'
    },
    {
        abbreviation: 'OK',
        stateName: 'Oklahoma'
    },
    {
        abbreviation: 'OR',
        stateName: 'Oregon'
    },
    {
        abbreviation: 'PW',
        stateName: 'Palau'
    },
    {
        abbreviation: 'PA',
        stateName: 'Pennsylvania'
    },
    {
        abbreviation: 'PR',
        stateName: 'Puerto Rico'
    },
    {
        abbreviation: 'RI',
        stateName: 'Rhode Island'
    },
    {
        abbreviation: 'SC',
        stateName: 'South Carolina'
    },
    {
        abbreviation: 'SD',
        stateName: 'South Dakota'
    },
    {
        abbreviation: 'TN',
        stateName: 'Tennessee'
    },
    {
        abbreviation: 'TX',
        stateName: 'Texas'
    },
    {
        abbreviation: 'UT',
        stateName: 'Utah'
    },
    {
        abbreviation: 'VT',
        stateName: 'Vermont'
    },
    {
        abbreviation: 'VI',
        stateName: 'Virgin Islands'
    },
    {
        abbreviation: 'VA',
        stateName: 'Virginia'
    },
    {
        abbreviation: 'WA',
        stateName: 'Washington'
    },
    {
        abbreviation: 'WV',
        stateName: 'West Virginia'
    },
    {
        abbreviation: 'WI',
        stateName: 'Wisconsin'
    },
    {
        abbreviation: 'WY',
        stateName: 'Wyoming'
    },
];
